import React from "react";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import Moment from "moment"; import axios from "axios";
import API from "../helpers/api";
import swal from "sweetalert";
import { toast } from "react-toastify";
import { getOtherTask } from "../Actions/ShipViewAPI";
import { confirmAlert } from 'react-confirm-alert';

let userkey = JSON.parse(localStorage.getItem("currentUser"));
let user = localStorage.getItem("UserRoles");

class StaffOtherTask extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fromDateOpen: false,
            searchData: {
                taskType: "",
                taskdescription: "",
                taskdeadLine: "",
                filesPDF: '',
            },
            multifilesPDF: [],
            otherTask: [],
            taskData: false
        }
    }

    componentDidMount() {

    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { otherTaskList } = nextProps;
        if (otherTaskList && prevState.taskData === false) {
            prevState.otherTask.push(otherTaskList);
            prevState.taskData = true
        }
    }

    handleInputChange = (e) => {
        let nodeName = e.target.name;
        this.state.searchData[nodeName] = e.target.value;
        this.setState({});
    }

    handleDeadlineDateChange = (date) => {
        this.state.searchData.taskdeadLine = Moment(new Date(Date.parse(date))).format(
            "YYYY-MM-DD"
        );
        this.setState({
            fromDateOpen: false,
        });
    }

    openDeadlineDatePicker = () => {
        this.setState({
            fromDateOpen: !this.state.fromDateOpen
        });
    }

    handleBlur() {
        this.setState({
            fromDateOpen: false
        });
      }

    fileSelectedHandlers = (e) => {
        this.state.multifilesPDF = [...e.target.files]
        let file = "";
        let multifile = [...e.target.files]
        multifile.map((i, index) => {
            if (index === 0) {
                file = i.name
            }
            else {
                file = file + ', ' + i.name
            }
        })
        this.state.searchData.filesPDF = file;
        this.setState({});
    }

    ClearInputsPDF = () => {
        this.state.searchData.filesPDF = "";
        this.setState({ multifilesPDF: '' });
    }

    addOtherTask = () => {
        const { dispatch, match } = this.props;
        const { params } = match;
        const { shipId } = params;
        if (this.state.searchData.taskType === '') {
            swal('Error!', 'Please enter a task', 'warning');
        }
        else {
            this.state.taskData = false
            const data = new FormData()
            for (const postItem of this.state.multifilesPDF) {
                data.append('file', postItem)
            }

            let url = `${API.AttachmentsAPI}`;
            axios.post(url, data)
                .then((response) => {
                    if (response.data) {
                        let datas = response.data.map((i) => ({
                            isDeleted: false,
                            attachmentId: 0,
                            attachmentName: i.FileName,
                            attachmentGuid: i.Guid
                        }));
                        let tasks = {
                            shipId: parseInt(shipId),
                            task: this.state.searchData.taskType,
                            description: this.state.searchData.taskdescription,
                            deadLine: this.state.searchData.taskdeadLine,
                            attachments: datas,
                            createdBy: userkey.email
                        }
                        dispatch({ type: "GetOtherTaskList", data: tasks });
                        this.state.searchData.taskType = "";
                        this.state.searchData.taskdescription = "";
                        this.state.searchData.taskdeadLine = "";
                        this.state.searchData.filesPDF = "";
                        this.setState({ multifilesPDF: '' });
                    }
                    dispatch({
                        type: "AttachmentsUploadSuccess",
                        data: response.data,
                    })
                })
                .catch((error) => {
                    dispatch({
                        type: "AttachmentsUploadFailure",
                        error: "ERROR"
                    })
                })
        }
        // let task = {
        //     taskType: this.state.searchData.task,
        //     taskDescription: this.state.searchData.description,
        //     taskDeadline: this.state.searchData.deadLine,
        //     taskAttachment: this.state.searchData.filesPDF,
        // }
        // this.state.otherTaskList.push(task);
        // dispatch({ type: "GetOtherTaskList", data: this.state.otherTaskList });
    }

    SubmitOtherTask = () => {
        const { dispatch, match } = this.props;
        const { params } = match;
        const { shipId } = params;
        if (this.state.otherTask.length === 0) {
            swal('Error!', 'No Tasks, Please add task', 'warning');
        }
        else {
            let url = `${API.GetOtherTask}`;
            axios.post(url, this.state.otherTask)
                .then((response) => {
                    if (response.data) {
                        toast.success(' Added successfully.', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        this.props.history.push(`/Home/Ship/${shipId}/Tasks`);
                        dispatch(getOtherTask(parseInt(shipId), 1));
                    }
                    dispatch({
                        type: "OtherTaskUploadSuccess",
                        data: response.data,
                    })
                })
                .catch((error) => {
                    dispatch({
                        type: "OtherTaskUploadFailure",
                        error: "ERROR"
                    })
                })
        }
    }

    DeletePopup(index) {
        confirmAlert({
            message: 'Are you sure want to delete ?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        this.deleteTask(index)
                    }
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        });
        }

    deleteTask = (index) => {
        
        this.state.otherTask.splice(index, 1);
        this.setState({});
    }

    CancelTask = () => {
        const { match } = this.props;
        const { params } = match;
        const { shipId } = params;
        this.props.history.push(`/Home/Ship/${shipId}/Tasks`);
        this.props.dispatch({ type: "GetOtherTaskList", data: "" });
    }

    render() {
        const { otherTask } = this.state
        
        return (
            <div className="full-height">
                <div className="resource-list-auth-date row pt-3">
                    <div className="col-lg-12">
                        <div className="panel-box search-filter-box">
                            <div className="card MM-card-header mt-2 mb-0" style={{ backgroundColor: "white", border: "0px" }}>
                                <div className="card-body">
                                    <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                        Add Hazardous Material Removal
                                        </h5>
                                </div>
                            </div>
                            <div className="search-filter-box">
                                <div className="row pb-1">
                                    <div className="col-lg-4">
                                        <label className="form-label">Task</label>
                                        <br></br>
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="taskType"
                                            placeholder="Task"
                                            value={this.state.searchData.taskType}
                                            onChange={e => this.handleInputChange(e)}
                                        ></input>
                                    </div>
                                    <div className="col-lg-4">
                                        <label className="form-label">Description</label>
                                        <br></br>
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="taskdescription"
                                            placeholder="Description"
                                            value={this.state.searchData.taskdescription}
                                            onChange={e => this.handleInputChange(e)}
                                        ></input>
                                    </div>
                                    <div className="col-lg-4">
                                        <label className="form-label">Deadline</label>
                                        <div
                                            className="input-group add-on date datepicker"
                                            data-date-format="yyyy-mm-dd"  >
                                            <input
                                                type="text"
                                                value={this.state.searchData.taskdeadLine}
                                                className="form-control date-picker"
                                                placeholder="Deadline"
                                                name="POFromDate" ></input>
                                            <DatePicker
                                                onChange={this.handleDeadlineDateChange}
                                                open={this.state.fromDateOpen}
                                                onClickOutside={this.handleBlur}
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                popperPlacement="top-end"
                                                className="form-control date-picker w-5 hide-date" />
                                            <div
                                                className="input-group-btn calendar-icon"
                                                onClick={this.openDeadlineDatePicker}
                                            >
                                                <button className="btn btn-default" style={{ height: "100%" }}>
                                                    <i className="fa fa-calendar mt-1"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <label className="form-label" >Attachments : </label><br></br>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">Browse File<input type="file" id="files"  style={{ marginRight: 40 }} multiple name="fileName" onChange={this.fileSelectedHandlers} /></span>
                                            </div>
                                            <input type="text" class="form-control" placeholder="No file chosen" value={this.state.searchData.filesPDF} />
                                            {
                                                this.state.searchData.filesPDF ?
                                                    <div class="input-group-append" style={{cursor:"pointer"}}>
                                                        <i class="fa fa-times input-group-text" aria-hidden="true" onClick={() => this.ClearInputsPDF()}></i>
                                                    </div> : ''
                                            }

                                        </div>
                                    </div>
                                    <div className="col-lg-8 pt-3">
                                        <label></label><br></br>
                                        <div className="search-btn-col" style={{ textAlign: "end" }}>
                                            <button
                                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                type="submit"
                                                onClick={() => this.addOtherTask()}
                                            >
                                                {" "}Add Task{" "}
                                            </button>
                                            {/* <button
                                                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                type="button"
                                                onClick={() => this.CancelSidePanel()}
                                            >
                                                {" "}Cancel{" "}
                                            </button> */}
                                        </div>
                                    </div>

                                </div>
                            </div>

                            {otherTask && otherTask.length ? otherTask.map((item, index) => (
                                <div className="card click m-3" style={{ backgroundColor: "#f0f0f0", overflow: "hidden", position: "relative" }}>
                                    <div className="p-3">
                                        <div className="resource-list-auth-date">
                                            <div className="row">
                                                <div className="col-sm-10 col-md-11 col-10 m-auto">
                                                    <div className="row">
                                                        <div className="col-sm-3">
                                                            <span><strong>Task : </strong>{item.task}</span>
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <span><strong>Description : </strong>{item.description}</span>
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <span><strong>Deadline : </strong>{item.deadLine}</span>
                                                        </div>
                                                        {/* <div className="col-sm-3">
                                                            <strong>Attachments : </strong>{item.attachments.map(items => (<span>{items.attachmentName.toString()}</span>))}
                                                        </div> */}
                                                        <div className="col-sm-3">
                                                            <strong>Attachments : </strong>{
                                                                item.attachments && item.attachments.map((items, index) => {
                                                                    return (
                                                                        <span class="italicFont ">{items.attachmentName}
                                                                            {item && item.attachments ?
                                                                                <>
                                                                                    {item.attachments.length === 1 ? "" : item.attachments.length === index + 1 ? "" : <strong>,  </strong>}
                                                                                </>
                                                                                : null}
                                                                        </span>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-2 col-md-1 col-2 m-auto">
                                                    <div className="text-center">
                                                        <i className="fa fa-trash fa-2x" style={{ marginLeft: '-15px' }} onClick={() => this.DeletePopup(index)}></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                                :
                                <div className="card m-3" style={{ overflow: "hidden", position: "relative" }}>
                                    <div class="container">
                                        <h6 className="resource-list-title no-item-card mb-2">
                                            No Tasks
              </h6>
                                    </div>
                                </div>
                            }


                            <div className="col-lg-12">
                                <label></label><br></br>
                                <div className="search-btn-col mb-1" style={{ textAlign: "end" }}>
                                    <button
                                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                        type="submit"
                                        onClick={() => this.SubmitOtherTask()}
                                    >
                                        {" "}Submit{" "}
                                    </button>
                                    <button
                                        className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                        type="button"
                                        onClick={() => this.CancelTask()}
                                    >
                                        {" "}Cancel{" "}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        otherTaskList: state.ShipViewReducer.otherTaskList
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(StaffOtherTask);